<template>
  <v-container class="container-layout py-1">
    <template>
      
      <div>
        <div>
          <v-row dense>
            <v-col cols="12" md="7">
            </v-col>
            <v-col cols="12" md="5" class="text-right">
              <span style="color: #000;">申込日
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
              </span>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <div class="block">
                DXE株式会社　宛
              </div>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <h3 class="text-center" style="color: #000;">
                JWNET加入申込書（団体加入用）兼JWNET-EDI連携サービス申込書
              </h3>
            </v-col>
          </v-row>

          <!-- ヘッダー文章・リンク -->
          <v-row dense>
            <v-col cols="12">
              <div class="block" style="width: 100%;font-size:87%; line-height: 22px">
                公益財団法⼈⽇本産業廃棄物処理振興センター(以下、JWセンターという。)の「電⼦マニフェスト加⼊規約」及び添付の
                <br>
                「ＪＷＮＥＴ－ＥＤＩ連携サービス利用規約」に承諾し、 DXE株式会社を利⽤代表者としてJWセンターが提供するJWNETサービスに申し込みます。
                <br>
                電⼦マニフェスト加⼊規約［<a href="https://www.jwnet.or.jp/jwnet/youshiki/procedure/kiyaku.html" target="_blank">https://www.jwnet.or.jp/jwnet/youshiki/procedure/kiyaku.html</a>］
              </div>
            </v-col>
          </v-row>
          <!-- /ヘッダー文章・リンク -->

          <!-- 排出事業者／排出事業場 -->
          <v-row dense>
            <v-col cols="12">
              <div class="table strong" style="width: 100%;">
                <div class="table_line">
                  <div class="block title_label text-center bordered_b" style="width: 16%;">
                    <h4>加入者<br>
                    （ご契約者）</h4>
                  </div>
                  <div class="block" style="width: 84%;">

                    <!-- 名称 -->
                    <div class="table_line" style="height:8mm">
                      <div class="block label custom-dashed-req bordered_l bordered_r" style="width: 12%;">
                        <h4>（フリガナ）</h4>
                      </div>
                      <div class="block custom-dashed-label" style="width: 72%;">
                      </div>
                    </div>

                    <div class="table_line" style="height:15.5mm">
                      <div class="block label req bordered_b bordered_l bordered_r" style="width: 12%;">
                        <h4>名称</h4>
                      </div>
                      <div class="block bordered_b" style="width: 72%;">
                      </div>
                    </div>
                    <!-- /名称 -->

                    <!-- 代表者 -->
                    <div class="table_line" style="height:8mm">
                      <div class="block label custom-dashed-req bordered_l bordered_r" style="width: 12%;">
                        <h4>（フリガナ）</h4>
                      </div>
                      <div class="block custom-dashed-label bordered_name_r" style="width: 36%;">
                      </div>
                      <div class="block custom-dashed-label" style="width: 36%;">
                      </div>
                    </div>

                    <div class="table_line" style="height:15.5mm">
                      <div class="block label req bordered_b bordered_l bordered_r" style="width: 12%;">
                        <h4>代表者名</h4>
                      </div>
                      <div class="block bordered_b bordered_name_r" style="width: 36%;">
                      </div>
                      <div class="block bordered_b" style="width: 36%;">
                      </div>
                    </div>
                    <!-- /代表者 -->

                    <!-- 住所 -->
                    <div class="table_line" style="height:16mm">
                      <div class="block label req bordered_b bordered_l bordered_r" style="width: 12%;">
                        <h4>住所</h4>
                      </div>
                      <div class="block bordered_b" style="width: 72%;">
                        &nbsp;&nbsp;〒
                      </div>
                    </div>
                    <!-- /住所 -->

                    <!-- TEL -->
                    <div class="table_line" style="height:8mm">
                      <div class="block label req bordered_b bordered_l bordered_r" style="width: 12%;">
                        <h4>TEL</h4>
                      </div>
                      <div class="block bordered_b" style="width: 72%;">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ー</b>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ー</b>
                      </div>
                    </div>
                    <!-- /TEL -->
                  </div>
                </div>

                <div class="table_line">
                  <div class="block title_label text-center bordered_b" style="width: 16%;">
                    <h4>事務ご担当者</h4><div class="block" style="font-size:60%;">代表者と異なる場合のみご記入下さい。</div>
                  </div>

                  <!-- 担当者・名称 -->
                  <div class="table_line" style="height:8mm">
                    <div class="block label custom-dashed-label bordered_l bordered_r" style="width: 12%;">
                      <h4>（フリガナ）</h4>
                    </div>
                    <div class="block custom-dashed-label bordered_name_r" style="width: 36%;">
                    </div>
                    <div class="block custom-dashed-label" style="width: 36%;">
                    </div>
                  </div>

                  <div class="table_line" style="height:15.5mm">
                    <div class="block label bordered_b bordered_l bordered_r" style="width: 12%;">
                      <h4>氏名</h4>
                    </div>
                    <div class="block bordered_b bordered_name_r" style="width: 36%;">
                    </div>
                    <div class="block bordered_b" style="width: 36%;">
                    </div>
                  </div>
                  <!-- /名称・担当者 -->

                  <!-- TEL -->
                  <div class="table_line" style="height:8mm">
                    <div class="block label bordered_b bordered_l bordered_r" style="width: 12%;">
                      <h4>TEL</h4>
                    </div>
                    <div class="block bordered_b" style="width: 72%;">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ー</b>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ー</b>
                    </div>
                  </div>
                  <!-- /TEL -->
                </div>

                <div class="table_line" style="height:10.5mm">
                  <div class="block text-center label req bordered bordered_b" style="width: 16%;">
                    <h4>連絡先メール<br>アドレス(※1)</h4>
                  </div>
                  <div class="block bordered_b bordered_l bordered_r" style="width: 48%;">
                  </div>
                  <div class="block label req bordered_b bordered_r" style="width: 10%;">
                    <h4>業種(※2)</h4>
                  </div>
                  <div class="block bordered_b" style="width: 34%;">
                  </div>
                </div>

                <div class="table_line" style="font-size:57%; line-height: 17px">
                  &nbsp;(※1) 連絡先メールアドレスは、JWセンターからの手続きやシステム等に関する重要なお知らせの配信先ですので、必ずご記入下さい。<br>
                  &nbsp;(※2) ご記載ない場合は、弊社にて設定致します。<br>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /排出事業者／排出事業場 -->

          <!-- 公開希望欄 -->
          <v-row dense>
            <v-col cols="12" class="py-0">
              <div class="block" style="font-size:90%;">
                <b>
                JWNETで加⼊者情報の公開をご希望の方は以下のご記⼊もお願い致します。 <br>
                □加⼊者名と、以下のURLにて加⼊者情報の公開を希望します。　　　□加⼊者名のみ公開を希望します。
                </b>
              </div>
            </v-col>
          </v-row>
          <!-- /公開希望欄 -->

          <!-- 公開希望欄 -->
          <v-row dense>
            <v-col cols="12">
              <div class="table" style="width: 100%;">
                <div class="table_line mt-1" style="font-size:120%; height:8mm;">
                  &nbsp;&nbsp;<b><u>https://</u></b>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /公開希望欄 -->

          <!-- 注意事項 -->
          <v-row dense>
            <v-col cols="12">
              <div class="table" style="width: 100%;border: none;">
                <div class="table_line" style="font-size:72%; line-height: 20px">
                  ■注意事項<br>
                  ・DXE株式会社を利⽤代表者として加⼊した加⼊者番号は、<u>DXEサービスを利用した取引のみ</u>で使用可能です。万が⼀、DXEサービスを<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;利用しない取引による使⽤が明らかになった場合はJWNETからの請求に基づいて別途使⽤料をお⽀払頂くことになりますので予めご了承下さい。<br>
                  ・DXE株式会社を利用代表者として加入した加入者番号が、加入後18ケ月に亘りDXEシステムの利用がない状態が継続した場合、<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;次に到来する12月末時点をもって、団体加入取消しの手続き行うものとします。<br>
                  ・<u>連絡先メールアドレスは必ずご記入ください。</u>ご記⼊いただけない場合は、受付出来かねますのでご了承ください。<br>
                  ・お申込み後は弊社にて順次手続き致します。⼿続きが完了しますと連絡先メールアドレス宛で加入者番号、仮パスワードのメールが<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;届きますのでご確認ください。通常１〜２週間で手続きは完了致しますが、メールが届かない場合はDXE株式会社にお問い合わせください。<br>
                  ・加⼊後に加入証が必要な場合は、JWNETにログインしてお客様自身にて印刷いただきますようお願い致します。<br>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- /注意事項 -->

          <!-- フッター -->
          <!-- サイン欄 -->
          <v-row dense>
            <v-col cols="6">
              <v-row dense class="pt-14">
                <v-col cols="12">
                  <div class="table" style="width: 100%;border: none;">
                    <div class="table_line" style="font-size:90%;">
                      DXE株式会社記入欄
                    </div>
                  </div>

                  <div class="table" style="width: 100%; border: 1px solid #000">
                    <div class="table_line">
                      <div class="block bordered_r" style="width: 35%;">
                        <span class="pl-1" style="font-size:85%;">処理業者</span>
                      </div>
                      <div class="block" style="width: 65%;">
                        <span class="pl-1" style="font-size:85%;">
                          &nbsp;&nbsp;{{ tenant.subscriber_number }}<br>
                          &nbsp;&nbsp;{{ tenant.name }}&nbsp;&nbsp;&nbsp;&nbsp;様
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row dense class="pull-right pt-0 pb-12">
                <div class="table strong" style="width: 90%;height:35mm; font-size:80%; margin-left: auto; margin-right: 4px;">
                  <div class="block pl-2 pt-1" style="line-height: 25px">
                  利用規約に同意し、上記の内容で申し込みます。<br>
                  お客様ご確認欄<span style="font-size:70%;">（ご記入頂いた方のフルネームサインをお願い致します）</span>
                  </div>
                </div>
              </v-row>
            </v-col>
          </v-row>
          <!-- /サイン欄 -->
          <!-- /フッター -->
        </div>
        <hr class="print-break" style="margin-top: 5px;margin-bottom: 5px;" />

        <div class="pt-5">
          <!-- 規約文章 -->
          <v-row dense>
            <v-col cols="12">
              <div class="block" style="font-size:85%;"
                  v-html="tenant.terms_of_edi_request">
              </div>
            </v-col>
          </v-row>
          <!-- /規約文章 -->

          <!-- <hr class="print-break" style="margin-top: 5px;margin-bottom: 5px;" /> -->
        </div>

      </div>
    </template>
  </v-container>

</template>

<script>
export default {
  name: "JwnetJoinApplicationFormTemplate",
  components: {},
  mixins: [],
  props: {
    tenant: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      systemTime: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.systemTime = this.$dayjs().format("YYYY/MM/DD HH:mm")
  },
  updated() {
    /** @typedef document */
    document.title = 'DXE Station EDI Form - type1'
  },
  methods: {}
}
</script>

<style scoped lang="scss">
body {
  overflow-y: scroll;
  height: auto;
}
.container-layout {
  border: solid 1px #ddd;
  background-color: #fff;
  width: 210mm;
}

.table {
  border: 1px solid #000;
  &.strong {
    border: 3px solid #000;
  }
}

.table_line {
  display: table;
  width: 100%;
  color: #000;
  &.furigana {
    border-bottom: 1px dashed #000;
    height: 5mm;
    font-size:60%;
  }
}

.custom-dashed-label {
  // height: 50px;
  /* 下線のみにカスタム破線を適用 */
  background-image: linear-gradient(to right, #000 50%, rgba(255,255,255,0) 0%);
  background-position: bottom;
  background-size: 14px 1px; /* 10px(線の長さ+間隔) 2px(線の太さ) */
  background-repeat: repeat-x;
}

.custom-dashed-req {
  // height: 50px;
  /* 下線のみにカスタム破線を適用 */
  background-image: linear-gradient(to right, #000 50%, rgba(255,255,255,0) 0%);
  background-position: bottom;
  background-size: 14px 1px; /* 10px(線の長さ+間隔) 2px(線の太さ) */
  background-repeat: repeat-x;
  background-color: #dddddd;
}

.block {
  display: table-cell;
  vertical-align: initial;
  color: #000;

  &.req {
    background-color: #dddddd;
  }

  &.title_label {
    text-align: center;
    vertical-align: middle;
    font-size: 100%;
  }

  &.label {
    text-align: center;
    vertical-align: middle;
    font-size: 85%;
  }

  &.bordered_l {
    border-left: solid 1px #000;
  }

  &.bordered_r {
    border-right: solid 1px #000;
  }

  &.bordered_b {
    border-bottom: solid 1px #000;
  }

  &.bordered_name_r {
    border-right: dashed 1px #000;
  }

  & span {
    vertical-align: center;
  }

  /* v-html内のスタイル */
  /deep/ p {
    margin-bottom: 0;
    &.ql-align-center {
      text-align: center;
    }
    &.ql-align-right {
      text-align: right;
    }
    &.ql-align-justify {
      text-align: left;
    }
  }

  /deep/ pre {
    background-color: black;
    color: white;
    overflow: visible;
  }

  /deep/ blockquote {
    border-left: 4px solid #CCC;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }

}

hr {
  page-break-after: always;
}
@media print {
  .container-layout {
    border: none;
  }
  .print-break {
    page-break-after: always;
    border: none;
  }
}
</style>
